export default __webpack_public_path__ + "static/hero-top-df0c471ef49a2df9ecb2c0a2bf198492.svg";